import { jsx as _jsx } from "react/jsx-runtime";
import { styled, css } from 'styled-components';
export const Wrapper = styled.div `
  min-height: 38px;
  flex: 0 0 auto;
  * {
    flex: 0 0 100%;
  }
  ${({ $formActive, theme }) => !$formActive &&
    css `
      display: flex;
      align-items: center;
      padding: 8px 12px;
      font-size: 14px;
      border-radius: 4px;
      border: 1px solid ${theme.colors.grey30_1};
      color: ${theme.colors.black_1};
      background: ${theme.colors.grey00_7};
    `}
`;
const PseudoText = ({ children, value, formActive, onDoubleClick }) => (_jsx(Wrapper, { onDoubleClick: onDoubleClick, "$formActive": formActive, children: formActive ? children : value }));
export default PseudoText;
